<template>
    <!-- Start Clients Section -->
    <section class="clients-section section">
        <div class="container">
            <div class="title-section z-index position-relative wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                <div class="subtitle-hr d-flex align-items-center">
                    <h6 class="subtitle text-white text-uppercase position-relative">Promotions</h6>
                    <hr class="white-border">
                </div>
                <h2 class="title text-md-left text-center f-40 text-white">Explore Our Latest Deals!</h2>
            </div>
            <div class="mt-4 owl-carousel owl-theme clients-slider wow fadeIn" data-wow-duration="1000ms">
                <div class="px-3 item wow fadeIn" data-wow-delay="0.2s" data-wow-duration="1s" v-for="promotion in promotions" :key="promotion.name">
                    <div class="user-pics overflow-hidden mx-auto">
                        <img :src="promotion.image" alt="" class="img-fluid">
                    </div>
                    <div class="clients-card bg-white">
                        <div class="user-txt text-sm-left text-center">
                            <div class="use-info">
                                <h5 class="theme-color">{{promotion.name}}</h5>
                            </div>
                        </div>
                        <div class="shadow-md">
                            <p class="m-0 text-sm-left text-center f-16 font-weight-medium"><em>{{promotion.details}}</em> </p>
                        </div>
                    </div>
                </div>

              
                
             
            </div>
        </div>
    </section>
    <!-- End Clients Section -->
</template>

<script>

let image="";

export default {
    name: "promotions",
    data() {
        return {
            promotions: [{ 
                    image: 'assets/images/promotions/discount.png',
                    name: 'Discount on assessments',
                    details: 'Take advantage of our exclusive opportunity with 10% off your total cost if you sign up today! Limited time offer!'
                },
                {
                    image: 'assets/images/promotions/consultation.png',
                    name: 'Free consultation',
                    details: 'Our assessments are a great fit to explore ways to expand and maximize your organization’s potential.'
                }

            ]
        }
    },
    methods: {

    },
    mounted() {

        //alert("Product type: "+this.product);
    }
}
</script>
